import styled from 'styled-components';

const StyledEducationImage = styled.div`
  position: relative;
  aspect-ratio: 3/2;

  .category-image__title-container {
    position: absolute;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 10px;

    .category-image__title {
      color: white;
      text-align: center;
    }
  }
  .category-image {
    width: 100%;
    overflow: hidden;
    border-radius: 2%;
    width: 100%;
    height: 100%;
    clip-path: polygon(
      ${props => props.corner && props.corner} 0,
      100% 0,
      100% 100%,
      0 100%,
      0 ${props => props.corner && props.corner}
    );

    .category-image__clip {
      overflow: hidden;
      width: 100%;
      height: 100%;

      .category-image__src {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }
`;

export default StyledEducationImage;
